import { get } from 'services/api';

export const PURCHASES_URL = '/i/purchases';

export const getPurchases = () => get(PURCHASES_URL);
